// Copyright (c) 2024 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.

export const theme = {
    eCashBlue: '#00ABE7',
    eCashPurple: '#ff21d0',
    darkBlue: '#273498',
    contrast: '#fff',
    panel: '#26415a',
    backgroundImage: `url("/cashtab_bg.png")`,
    backgroundThemeImage: `url("/PurpleWallet-BackgroundNew.svg")`,
    backgroundColor: '#d5d5d7',
    // walletBackground: "#152b45",
    // walletBackground: "linear-gradient(to bottom, #4B0082, #273498)",
    walletInfoContainer: '#255173',
    headerAndFooterBg: '#152b45',
    navActive: '#00ABE7',
    encryptionRed: '#DC143C',
    genesisGreen: '#00e781',
    aliasGreen: '#0FFF50',
    separator: 'rgba(255, 255, 255, 0.12)',
    receivedMessage: 'rgba(0,171,231,0.2)',
    sentMessage: 'rgba(255, 255, 255, 0.1)',
    lightWhite: 'rgba(255,255,255,0.4)',
    lightGrey: 'hsla(0, 0%, 49.8%, 0.65);',
    dropdownText: '#000',
    shadow: 'rgba(0, 0, 0, 0.4)',
    switchButtonActiveText: '#fff',
    advancedCollapse: {
        background: '#255173',
        color: '#fff',
        icon: '#fff',
        expandedBackground: 'rgba(0,0,0,0.2)',
    },
    forms: {
        error: '#FF21D0',
        border: '#17171f',
        text: '#fff',
        addonBackground: '#255173',
        addonForeground: '#fff',
        selectionBackground: '#255173',
        placeholder: 'rgba(255,255,255,0.3)',
        highlightBox: '#00ABE7',
    },
    icons: {outlined: '#fff'},
    settings: {
        delete: '#CD0BC3',
        background: 'rgba(0,0,0,0.4)',
    },
    qr: {
        background: '#fff',
    },
    buttons: {
        primary: {
            backgroundImage:
                'linear-gradient(270deg, #0074C2 0%, #273498 100%)',
            color: '#fff',
            hoverShadow: '0px 3px 10px -5px rgba(0, 0, 0, 0.75)',
        },
        secondary: {
            backgroundImage:
                'linear-gradient(270deg, #ff21d0 0%, #273498 100%)',
            color: '#fff',
        },
        modal: {
            // Some transparency added to ecashPurple for modal 'later'
            background: '#ff21d080',
        },
        disabled: {
            background: '#4b67e1',
            color: 'rgba(255,255,255,0.4)',
        },
        styledLink: '#ffffff',
    },
    collapses: {
        background: '#255173',
        expandedBackground: '#26415a',
        border: '#17171f',
        color: '#fff',
    },
    modal: {
        background: '#255173',
        border: '#17171f',
        color: '#fff',
        buttonBackground: '#26415a',
    },
};
